import { render } from "./ManagerLogs.vue?vue&type=template&id=586406fa&scoped=true"
import script from "./ManagerLogs.vue?vue&type=script&lang=js"
export * from "./ManagerLogs.vue?vue&type=script&lang=js"

import "./ManagerLogs.vue?vue&type=style&index=0&id=586406fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586406fa"]])

export default __exports__